import reactstrapCjs from "reactstrap";
import React from "react";
import KickImage from 'Reuseables/KickImage';
import styled from "styled-components";

const AuthenticateInfo = () => (
  <AuthenticWrapper>
    <p>Authentic. Guaranteed.</p>
    <p>We guarantee your style with authentic product.</p>
  </AuthenticWrapper>
)

const AuthenticWrapper = styled.div`
  height: auto;
  width: 100%;
  padding: 20px 0;
  border: solid 1px #707070;
  background-color: #242424;
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    font-size: 14px;
    color: #FFF;
    font-family: Nunito Bold;
    text-align: center;
    margin-bottom: 0.5rem;
    &:last-child{
      font-family: Nunito Light;
      margin-bottom: 0;
    }
  }

  @media(max-width: 480px){
    padding: 20px 0;
    p {
      font-size: 12px;
    }
  }
`

export default AuthenticateInfo;